import { navigate } from '@reach/router';

function logoutUser() {
  sessionStorage.removeItem('loanForceInsiderPortal');

  navigate('/login');
}

export default logoutUser;
